import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Table } from 'reactstrap';
import React from 'react';
const formatDate = dateToTransform => {
  const date = new Date(dateToTransform);

  return date.toLocaleString('en-US', { hour12: false });
};
const NumberOrderHistoryModal = ({ data, title, onCancel, isOpen }) => {
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>
        <div>{title}</div>
      </ModalHeader>
      <ModalBody style={{ maxHeight: '80vh', overflowY: 'scroll' }}>
        <Table>
          <thead>
            <tr>
              <th>Order #</th>
              <th>Created Date</th>
              <th>Closed Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {data.map(item => {
              return (
                <tr key={item.orderId}>
                  <td>{item.orderId}</td>
                  <td>{formatDate(item.createdDate)}</td>
                  <td>{formatDate(item.closedDate)}</td>
                  <td>{item.orderStatus}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel}>
          {'Close'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default NumberOrderHistoryModal;
